/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_spotlight = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		var slideNumber = 0;

		/**
		 * Set timer and switch slides
		 */
		setInterval(function () {

			/** 
			 * Remove active class from all slides
			*/
			$('.js-spotlight-slideshow .slide').removeClass('active');

			/**
			 * Increase slide number
			 */
			slideNumber++;

			/**
			 * Reset slide number if exceeds total slides
			 */
			if (slideNumber > $('.js-spotlight-slideshow .slide').length) {
				slideNumber = 1;
			}

			/**
			 * Activate next slide
			 */
			$('.js-spotlight-slideshow .slide[data-slide="' + slideNumber + '"]').addClass('active');

		}, 2000);

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_spotlight);